import { EndpointUrl } from 'api/endpoint';
import { useCurrentUser } from 'api/providers/authProvider';
import { useWorkspaceId } from 'api/providers/workspaceProvider';
import useSWR, { BareFetcher, SWRConfiguration } from 'swr';

export function useFetch<T>(
  method = 'GET',
  body?: any,
  args?: Parameters<typeof fetch>,
) {
  const user = useCurrentUser();
  const workspaceId = useWorkspaceId();

  return {
    isValid: !!user && !!workspaceId,
    workspaceId,
    fetcher: async (url: string) => {
      const response = await fetch(url, {
        ...(args ? args[1] : {}),
        method,
        body: body ? JSON.stringify(body) : undefined,
        headers: {
          'Content-Type': body ? 'application/json' : (undefined as any),
          ...(args?.[1]?.headers ? args[1]?.headers : {}),
          'x-finsight-token': user?.token || '',
        },
      });

      if (!response.ok) throw new Error('Network response was not ok');

      const data = await response.json();
      return data as T;
    },
  };
}

export function useFetcher<T>(
  url: string | null,
  workspaceScope = true,
  swrOptions?: SWRConfiguration<T, T, BareFetcher<T>>,
) {
  const { isValid, workspaceId, fetcher } = useFetch<T>();
  return useSWR(
    EndpointUrl && isValid && url
      ? workspaceScope
        ? `${EndpointUrl}/workspace/${workspaceId}/${url}`
        : `${EndpointUrl}/${url}`
      : null,
    fetcher,
    swrOptions,
  );
}
